import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, CheckCircle } from 'lucide-react';
const NOTIFICATIONS = ['María L. de Buenos Aires acaba de unirse al MegaPack', 'Carlos R. de Córdoba descargó el MegaPack hace 3 minutos', 'Luciana M. de Rosario se unió hace 5 minutos', 'Fernando G. de Mendoza acaba de completar su compra', 'Valentina S. de La Plata descargó el MegaPack hace 8 minutos', 'Diego P. de Tucumán se unió hace 12 minutos', 'Camila R. de Mar del Plata acaba de unirse', 'Martín H. de Salta completó su compra hace 2 minutos'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Initial delay
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    const rotationTimer = setInterval(() => {
      setIsVisible(false); // Fade out
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % NOTIFICATIONS.length);
        if (!isDismissed) setIsVisible(true); // Fade in new one
      }, 1000); // Wait for fade out
    }, 8000); // Rotate every 8 seconds
    return () => clearInterval(rotationTimer);
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  return <AnimatePresence data-id="element-191">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-4 left-4 z-50 max-w-xs md:max-w-sm" data-id="element-192">
          <div className="bg-dark-surface/95 backdrop-blur-md border border-violet-glow/50 rounded-lg p-4 shadow-[0_0_20px_rgba(139,92,246,0.3)] flex items-start gap-3 relative overflow-hidden" data-id="element-193">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-violet-500 to-indigo-500" data-id="element-194" />

            <div className="bg-violet-500/20 p-2 rounded-full shrink-0" data-id="element-195">
              <CheckCircle className="w-5 h-5 text-violet-light" data-id="element-196" />
            </div>

            <div className="flex-1 pr-4" data-id="element-197">
              <p className="text-sm font-medium text-white leading-snug" data-id="element-198">
                {NOTIFICATIONS[currentIndex]}
              </p>
              <p className="text-xs text-violet-light/70 mt-1" data-id="element-199">
                Verificado por Hotmart
              </p>
            </div>

            <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-white/40 hover:text-white transition-colors" aria-label="Cerrar notificación" data-id="element-200">
              <X className="w-4 h-4" data-id="element-201" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}